export enum ESearchableStatus {
    On = 1,
    Off = 0
}

export enum EProfile {
    isAttach = 1,
    isProfile = 0
}

export type TResumeAttribute = {
    id: number
    updatedDate: number
    updatedDateTime: string
    lastProcessedOn: string
    isAttach: EProfile
    isSearchable: ESearchableStatus
    allowSearchableDisplay: ESearchableStatus
    fileName: string
    link: string
    size: number
    isLastApplied: boolean
}

export type TAttachmentInfo = {
    fileName: string
    link: string
    size: number
    updatedDate: string
    resumeId: number
    status: number
    extension: string
    isSearchable: number
}

export enum EProfileType {
    AttachCV = 'attach-cv',
    Profile = 'profile'
}

export enum ERefreshProfile {
    Unset = 0,
    Daily = 1,
    Weekly = 2
}

export type TProfileSetting = {
    chooseCV: EProfileType
    resumeId: number
    chooseRefreshType: ERefreshProfile
    summary: string
}

export type TResumeSettingMeta = {
    isWorkingPreference: boolean
    isAttach: boolean
    isBasicInfo: boolean
    isContactInformation: boolean
}

export type TResumeSettingInfo = {
    attributes: Partial<TResumeAttribute>[]
    searchableStatus: ESearchableStatus
    unContactable: ESearchableStatus
    AttachmentInfo: Partial<TAttachmentInfo> | null
    preferLocation: {
        cityId?: number
        cityName?: string
        districts?: unknown[]
        locationId?: number
    }
    profileSetting: Partial<TProfileSetting>
}

export type TResumeSettingInfoResponse = {
    data: TResumeSettingInfo
    meta: TResumeSettingMeta
    status: {
        code: number
        message: string
    }
}
